import ReportPublisherButton from "components/ReportDropdown/FlagPublisherButton";
import PageHeader from "components/shared/PageHeader";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import publisherIcon from "icons/duotone/pen.svg";
import pluralize from "lib/pluralize";
import { EditionSerializersPublisher } from "types/serializers";

export default function PublisherHeader({ publisher }: { publisher: EditionSerializersPublisher }) {
  return (
    <div>
      <PageHeader
        title={publisher.name}
        icon={publisherIcon}
        description={`${
          publisher.name
        } is a publisher who has published at least ${
          publisher.editionsCount
        } ${pluralize("edition", publisher.editionsCount)}.`}
      >
        <ReportPublisherButton publisher={publisher} />
      </PageHeader>
      {publisher.parent ? (
        <Text as="p">
          <b>{publisher.name}</b> is a subsidiary of{" "}
          <TextLink href={`/publishers/${publisher.parent.slug}`}>
            <b>{publisher.parent.name}</b>
          </TextLink>.
        </Text>
      ) : (
        false
      )}
    </div>
  );
}